import { useQuery } from '@tanstack/react-query';
import { getBackstockAuditStatus } from 'services/scratcherService';
import type { OverdueBackstockPacksResponse } from '../../types';

export const useBackstockAuditStatus = (
  storeId?: string,
  options: { enabled?: boolean } = {}
) => useQuery<OverdueBackstockPacksResponse, Error>({
  queryKey: ['backstock-audit-status', storeId],
  queryFn: async () => {
    if (!storeId) {
      throw new Error('Store ID is required');
    }

    const response = await getBackstockAuditStatus(storeId);
    if (response.success && response.data) {
      return response.data;
    }

    throw new Error(response.error || 'Failed to load backstock audit status');
  },
  enabled: Boolean(storeId) && options.enabled !== false,
  staleTime: 60 * 1000,
});
